import Header from "../../../../Components/Header/Header"
import Sidebar from "../../../../Components/Sidebar/Sidebar"
import React, { useEffect, useState } from 'react'
import Select from 'react-select'
import ProjectWiseContractorPopup from "./ProjectWiseContractorPopup"
import DeletePopup from "../GardenPopup/DeletePopup"
import { ProjectNameDataDDL } from "../../../../Components/CommonDDL/ProjectNameDataDDL"
import { useAuthState } from "../../../../Helper/Context"
import { useDispatch, useSelector } from "react-redux"
import { ContractorNameDDL } from "../../../../Components/CommonDDL/ContractorNameDDL"
import { ProjectWiseContractorDeleteAPI, ProjectWiseContractorExportTableDataAPI, ProjectWiseContractorTableDataAPI } from "../../../../Redux/SidebarMasterSlice/ProjectWiseContractorSlice"
import { Pegination } from "../../../../Components/Pegination/Pegination"
import { Loading } from "../../../../Helper/Loading"
import moment from "moment";
import { useSearchParams } from "react-router-dom"
import { ProjectTypeDataDDL } from "../../../../Components/CommonDDL/ProjectTypeDataDDL"
import { GDProjectNameDDL } from "../../../../Components/CommonDDL/GDProjectNameDDL"
import { ProjectWiseContractorExportData } from "./ProjectWiseContractorExportData"

export const ProjectWiseContractor = () => {

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    const [searchParams] = useSearchParams()
    let searchName = searchParams.get("name")
    let ApiFlag = searchParams.get("ApiFlag")
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")
    let DashProjectTypeId = searchParams.get("DashProjectTypeId")

    const [PerPageCount, setPerPageCount] = useState(10)
    const [From, setFrom] = useState(1)
    const [To, setTo] = useState(10)
    const [rowNo, setrowNo] = useState(1)
    const [CurrentPage, setCurrentPage] = useState(0)
    const [IsPost, setIsPost] = useState(false)
    const [IsClear, setIsClear] = useState(false)
    const [SectorMasterPopupShow, setSectorMasterPopupShow] = useState()
    const [ProjectNamePopupShow, setProjectNamePopupShow] = useState()
    const [DeletePopupShow, setDeletePopupShow] = useState()
    const [ProjectWiseContractorPopupShow, setProjectWiseContractorPopupShow] = useState()
    const [ToDate, setToDate] = useState(moment().format('YYYY-MM-DD'))
    const [FromDate, setFromDate] = useState(moment().startOf('month').format('YYYY-MM-DD'))
    const [apiFlag, setapiFlag] = useState('')
    const [rowData, setrowData] = useState('')
    const [isSearch, setIsSearch] = useState(false)

    const [ProjectType, setProjectType] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [ProjectName, setProjectName] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [ContractorName, setContractorName] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const handleIsPost = () => {
        setIsPost(!IsPost)
    }

    const handleAddOnClick = () => {
        setapiFlag('Insert')
        setProjectWiseContractorPopupShow(true)
    }
    const handleEditOnClick = (item) => {
        setProjectWiseContractorPopupShow(true)
        setapiFlag('Update')
        setrowData(item)
    }

    const handleOnCloseClick = () => {
        setProjectWiseContractorPopupShow(false)
    }

    const handleDeleteApi = (item) => {
        const data = {
            M_ProjectWiseContractorID: item.m_ProjectWiseContractorID,
            M_UserID: UserID,
            token: token,
            handleIsPost: handleIsPost
        }
        dispatch(ProjectWiseContractorDeleteAPI({ data }))
    }

    const { isDeleteLoading } = useSelector(state => state.ProjectWiseContractorDeleteData)

    const handleClear = () => {
        setTo(10)
        setFrom(1)
        setCurrentPage(0)
        setIsClear(!IsClear)
        setProjectName({
            ...ProjectName,
            ID: 0,
            Label: 'Select...'
        })
        setContractorName({
            ...ContractorName,
            ID: 0,
            Label: 'Select...'
        })
        // setProjectType({
        //     ...ProjectType,
        //     ID: 0,
        //     Label: 'Select...'
        // })
    }

    useEffect(() => {
        // console.log(ProjectName.ID)
        const data = {
            M_ProjectWiseContractorID: '0',
            M_ProjectTypeID: ProjectTypeId == 1 ? DashProjectTypeId : ProjectTypeId,
            M_ProjectID: ProjectName.ID,
            M_ContractorID: ContractorName.ID,
            M_UserID: UserID,
            token: token,
            From: From,
            To: To,
            handleProjectWiseContractorExport:handleProjectWiseContractorExport
        }
        dispatch(ProjectWiseContractorTableDataAPI({ data }))
    }, [IsPost, To, IsClear, isSearch])

    const { tableData, isLoading } = useSelector(state => state.ProjectWiseContractorTableData)

    const handleProjectWiseContractorExport = () => {
        // console.log(ProjectName.ID)
        const data = {
            M_ProjectWiseContractorID: '0',
            M_ProjectTypeID: ProjectTypeId == 1 ? DashProjectTypeId : ProjectTypeId,
            M_ProjectID: ProjectName.ID,
            M_ContractorID: ContractorName.ID,
            M_UserID: UserID,
            token: token,
            From: '1',
            To: '99999',
        }
        dispatch(ProjectWiseContractorExportTableDataAPI({ data }))
    }
    // , [IsPost, IsClear, isSearch])

    const { ExportTableData, isExportLoading } = useSelector(state => state.ProjectWiseContractorExportTableData)

    const handleSearch = () => {
        setCurrentPage(0)
        setTo(10)
        setFrom(1)
        setIsSearch(!isSearch)
    }

    // const [SelectWard, setSelectWard] = useState({
    //     DDL: [],
    //     ID: 0,
    //     Label: "Select Ward.",
    // })

    return (
        <>
            {isLoading && <Loading />}
            {isDeleteLoading && <Loading />}
            <div>
                <Header
                    // DashboardHeading="Garden Maintainance"
                    DashboardName={DashboardName}
                />
                <div className="wrapper">
                    <Sidebar
                        ProjectTypeId={ProjectTypeId}
                        DashProjectTypeId={DashProjectTypeId}
                        active='projectwisecontractor' />
                    <div className="content">
                        <div className="data_mob">
                            <div className="row m-1 py-1 pb-4 master_border">
                                <div className='col-5'>
                                    <h5 className="mt-2">Project Wise Contractor Master</h5>
                                </div>
                                <div className='col-7 mar_add'>
                                    <div className="float-end butt">
                                        {
                                            isExportLoading ?
                                                <button type="button" className="btn btn-primary float-end mr-1 mb-1 ml-1" disabled>
                                                    <i
                                                        className="fa fa-refresh fa-spin"
                                                        style={{ marginRight: "5px" }}
                                                    />Loading</button>
                                                :
                                                // ExportTableData && ExportTableData.table && ExportTableData.table.length
                                                tableData && tableData.table && tableData.table.length > 0 &&
                                                <ProjectWiseContractorExportData
                                                    ExcelData={ExportTableData}
                                                    name='Project Wise Contractor Master'
                                                // searchName={searchName}
                                                />
                                        }
                                        <i className="fa-solid fa-plus float-end btn btn-secondary mb-2"
                                            style={{ color: "white" }}
                                            onClick={handleAddOnClick}
                                        >
                                            <text className="ml-2 poppins">Add</text>
                                        </i>
                                    </div>
                                </div>
                                <div className="row m-0 ">
                                    <div className="col-12 py-1 rounded rounded-2 shadow"
                                        style={{ border: "1px solid #00000024", background: " #27466317" }}>
                                        <div className="col-12">
                                            <div className="row py-1 rounded2 d-flex">
                                                {/* <div className="col-12 col-md-6 col-lg-3">
                                                    <ProjectTypeDataDDL
                                                        ProjectType={ProjectType}
                                                        setProjectType={setProjectType}

                                                    />

                                                </div> */}
                                                <div className="col-12 col-md-4 col-lg-3">
                                                    <GDProjectNameDDL
                                                        ProjectName={ProjectName}
                                                        setProjectName={setProjectName}
                                                        M_ProjectTypeID={ProjectTypeId == 1 ? DashProjectTypeId : ProjectTypeId}
                                                    // DDLFlag='ProjectWiseContractor'
                                                    />
                                                </div>
                                                <div className="col-12 col-md-4 col-lg-3">
                                                    <ContractorNameDDL
                                                        ContractorName={ContractorName}
                                                        setContractorName={setContractorName}
                                                    />
                                                </div>
                                                <div className="col-12 col-md-4 col-lg-3 mt-md-4 d-md-flex" >
                                                    <button type="button"
                                                        className="btn-clear btn btn-primary mx-2"
                                                        onClick={handleSearch}
                                                    >
                                                        Search</button>
                                                    <button type="button"
                                                        className="btn btn-outline-danger"
                                                        onClick={handleClear}
                                                    >
                                                        Clear</button>
                                                </div>
                                            </div>
                                            <div className="row mob_table table-responsive pt-1">

                                                <table id="totalordergenerated"
                                                    cellPadding="0"
                                                    cellSpacing="0"
                                                    border="0"
                                                    className="table table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th className="sr_no_col">Sr No.</th>
                                                            <th>Project Name</th>
                                                            <th>Contractor Name</th>
                                                            <th>From Date</th>
                                                            <th>To Date</th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            tableData && tableData.table && tableData.table.length > 0 ? tableData.table.map((item) => (
                                                                <tr style={{ width: '100%' }}>
                                                                    <td style={{ textAlign: 'center' }}>{item.rowNum}</td>
                                                                    <td>{item.projectName ? item.projectName : '-'}</td>
                                                                    <td>{item.contractorName ? item.contractorName : '-'}</td>
                                                                    <td>{item.fromDate ? moment(item.fromDate).format("DD-MM-YYYY") : '-'}</td>
                                                                    <td>{item.toDate ? moment(item.toDate).format("DD-MM-YYYY") : '-'}</td>
                                                                    <td style={{ textAlign: "center", width: '7%' }}>
                                                                        {/* <ProjectWiseContractorPopup
                                                                            open={ProjectWiseContractorPopupShow}
                                                                            item={item}
                                                                            Flag='Update'
                                                                            EditIcon='Update'
                                                                            handleIsPost={handleIsPost}

                                                                        /> */}
                                                                        <span>
                                                                            <i className="fa-solid fa-pen-to-square" title='Edit'
                                                                                style={{ cursor: 'pointer' }}
                                                                                onClick={() => handleEditOnClick(item)}
                                                                            >
                                                                            </i>
                                                                        </span>
                                                                        <span>
                                                                            <DeletePopup
                                                                                open={DeletePopupShow}
                                                                                handleDeleteApi={handleDeleteApi}
                                                                                item={item}

                                                                            />
                                                                        </span>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                                :
                                                                <td colSpan={10}>No data found</td>
                                                        }

                                                    </tbody>
                                                </table>

                                            </div>
                                            {tableData && tableData.table && tableData.table.length > 0 &&
                                                <Pegination
                                                    PerPageCount={PerPageCount}
                                                    TotalCount={tableData.table[0].totalCount}
                                                    setFrom={setFrom}
                                                    setTo={setTo}
                                                    setrowNo={setrowNo}
                                                    CurrentPage={CurrentPage}
                                                    setCurrentPage={setCurrentPage}
                                                />
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                {
                    ProjectWiseContractorPopupShow ?
                        <ProjectWiseContractorPopup
                            open={ProjectWiseContractorPopupShow}
                            popupHeading="Project Wise Contractor"
                            handleIsPost={handleIsPost}
                            handleOnCloseClick={handleOnCloseClick}
                            Flag={apiFlag}
                            rowData={rowData}
                            ProjectTypeId={ProjectTypeId}
                            DashProjectTypeId={DashProjectTypeId}
                        />
                        : <></>
                }
            </div>
        </>

    )
}